import React from "react";
import styled from "styled-components";
import { Typography } from "../typo-components";

import { Styles } from "../config";

const Vessel = styled.div`
  display: flex;
  flex: auto;
  flex-wrap: nowrap;
  align-items: center;
  border-radius: 999px;

  @media (max-width: 800px) {
    flex-wrap: wrap;
  }
`;


const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
  width: auto;

  border-bottom: ${(props) =>
    props.selected === props.value
      ? "2px solid #465578"
      : `2px solid ${Styles.Color.white}`};
  min-width: 100px;
  padding: 0 5px;
  height: ${(props) => (props.large ? "100px" : "35px")};
  transition: all 300ms ease-in-out;
  cursor: ${(props) =>
    props.selected !== props.value ? "pointer" : "default"};
  color: ${Styles.Color.primary};
  background: ${(props) =>
    props.selected === props.value
      ? Styles.Color.primary15
      : Styles.Color.white};
`;


const Switch = (props) => {
  const {
    options,
    value: selected,
    style,
    large,
    onClick,
    selectedAccessor,
  } = props;

  return (
    <Vessel style={style}>
      {options.map(({ label, value }) => {
        return (
          <Item
            key={label}
            options={options}
            selected={selected}
            value={selectedAccessor ? value?.[selectedAccessor] : value}
            large={large}
            onClick={(event) => {
              onClick({ ...event, target: { value } });
            }}
          >
            <Typography
              style={{
                padding: 0,
                textTransform: "capitalize",
                whiteSpace: "nowrap",
              }}
              color="primary"
              variant="t6"
              weight="semi"
              textAlign="center"
            >
              {label}
            </Typography>
          </Item>
        );
      })}
    </Vessel>
  );
};

export default Switch;
